export default __webpack_public_path__ + "static/media/crashCourse.dde31a75.svg";